import { render, staticRenderFns } from "./ChatInit.vue?vue&type=template&id=f50aeaae&scoped=true&"
import script from "./ChatInit.vue?vue&type=script&lang=js&"
export * from "./ChatInit.vue?vue&type=script&lang=js&"
import style0 from "./ChatInit.vue?vue&type=style&index=0&id=f50aeaae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50aeaae",
  null
  
)

export default component.exports